/**
 * @generated SignedSource<<97b099ed782a7741cbeebf8f4438fc49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OfferHistoryItem_offer$data = {
  readonly guid: string;
  readonly title: string;
  readonly advertiser: {
    readonly name: string | null;
  } | null;
  readonly pendingAmount: {
    readonly formatted: string;
  } | null;
  readonly approvedAmount: {
    readonly formatted: string;
  } | null;
  readonly rejectedAmount: {
    readonly formatted: string;
  } | null;
  readonly updatedAt: string;
  readonly " $fragmentType": "OfferHistoryItem_offer";
};
export type OfferHistoryItem_offer$key = {
  readonly " $data"?: OfferHistoryItem_offer$data;
  readonly " $fragmentSpreads": FragmentRefs<"OfferHistoryItem_offer">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "formatted",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OfferHistoryItem_offer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "guid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Advertiser",
      "kind": "LinkedField",
      "name": "advertiser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MoneyAmount",
      "kind": "LinkedField",
      "name": "pendingAmount",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MoneyAmount",
      "kind": "LinkedField",
      "name": "approvedAmount",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MoneyAmount",
      "kind": "LinkedField",
      "name": "rejectedAmount",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    }
  ],
  "type": "OfferStatus",
  "abstractKey": null
};
})();

(node as any).hash = "fcc11f559362c1cb84e9c6ec7faf72cc";

export default node;
